import styles from './providerNotice.module.scss';

const ProviderNotice = () => {
  return (
    <div className={styles.providerNoticeContainer}>
      <p className={styles.providerNoticeText}>表示順は「お客様の声」の件数も反映されています。</p>
    </div>
  );
};

export default ProviderNotice;
